// extracted by mini-css-extract-plugin
export default {"priceChartContainer":"price-chart_priceChartContainer__-juKl","priceChartWrapper":"price-chart_priceChartWrapper__tzhYR"};